import { Button, Icon, Menu, MenuItem, makeStyles } from "@material-ui/core";
import React, { useState } from "react";

import { useAuth } from "../../features/auth/context";
import { ViewEmployeeDialog } from "../shared/ViewEmployee";

export function UserMenu() {
    const classes = useStyles();
    const {
        username,
        logout,
        changePassword,
        isFederatedSsoUser,
    } = useAuth();

    const [userInfoDialogIsVisible, setUserInfoDialogIsVisible] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div className={classes.flexContainer}>
                {username}
                <Button onClick={handleClick}>
                    <div className={classes.flexContainer}>
                        <Icon>
                            account_circle
                        </Icon>
                        <Icon>
                            keyboard_arrow_down
                        </Icon>
                    </div>
                </Button>
            </div>
            <Menu
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorEl={anchorEl}
            >
                <MenuItem onClick={() => setUserInfoDialogIsVisible(true)}>
                    User Profile
                </MenuItem>

                <MenuItem onClick={changePassword} disabled={Boolean(isFederatedSsoUser)}>
                    Change Password
                </MenuItem>

                <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
            <ViewEmployeeDialog
                open={userInfoDialogIsVisible}
                forCurrentUser={true}
                onClose={() => setUserInfoDialogIsVisible(false)}
            />
        </>
    );
}

const useStyles = makeStyles(() => ({
    flexContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
    },
}));
